//清算中心
const Park = () => import(/*webpackChunkName:'split-accounting'*/'@/page/split-accounting/park/park.vue')
const ShareSpace=()=>import(/*webpackChunkName:'split-accounting'*/'@/page/split-accounting/share-space/share-space.vue')
const Withdrawal=()=>import(/*webpackChunkName:'split-accounting'*/'@/page/split-accounting/withdrawal/withdrawal.vue')
const ParkWithdrawalRecord=()=>import(/*webpackChunkName:'split-accounting'*/'@/page/split-accounting/withdrawal-record/park-withdrawal-record.vue')
const PersonWithdrawalRecord=()=>import(/*webpackChunkName:'split-accounting'*/'@/page/split-accounting/withdrawal-record/person-withdrawal-record.vue')
const PersonSplitBillRecord=()=>import(/*webpackChunkName:'split-accounting'*/'@/page/split-accounting/split-bill-record/person-split-bill-record.vue')

const ParkSplitBillRecord=()=>import(/*webpackChunkName:'split-accounting'*/'@/page/split-accounting/split-bill-record/park-split-bill-record.vue')

const ShareReportDay=()=>import(/*webpackChunkName:'split-accounting'*/'@/page/share-report-day/share-report-day.vue')

const RouteTemp = () => import(/*webpackChunkName:'split-accounting'*/'@/page/commons/routeTemp.vue')


export const settlementCenter ={
    path: '/main/settlement-center',
    name: '清算中心',
    component: RouteTemp,
    meta: {
        requireAuth: true,
    },
    children: [{
        path: '/main/split-accounting/park',
        name: '停车场',
        component: Park,
        meta: {
            requireAuth: true,
        },
    },
    {
        path:'/main/split-accounting/share-space',
        name: '共享车位',
        component: ShareSpace,
        meta: {
            requireAuth: true,
        },
    },
    {
        path:'/main/split-accounting/withdrawal',
        name: '提现',
        component: Withdrawal,
        meta: {
            requireAuth: true,
        },
    },
    {
        path:'/main/split-accounting/withdrawal/park-record',
        name: '车场提现记录',
        component: ParkWithdrawalRecord,
        meta: {
            requireAuth: true,
        },
    },
    {
        path:'/main/split-accounting/withdrawal/person-record',
        name: '个人提现记录',
        component: PersonWithdrawalRecord,
        meta: {
            requireAuth: true,
        },
    },
    {
        path:'/main/split-accounting/bill/park-record',
        name: '车场分账记录',
        component: ParkSplitBillRecord ,
        meta: {
            requireAuth: true,
        },
    },
    {
        path:'/main/split-accounting/bill/person-record',
        name: '个人分账记录',
        component: PersonSplitBillRecord,
        meta: {
            requireAuth: true,
        },
    },
    {
        path:'/main/split-accounting/share-report-day',
        name: '共享报表日统计',
        component: ShareReportDay,
        meta: {
            requireAuth: true,
        },
    }
]
}